import ajax from '@/utils/ajax';

const head = '/web';
// 用户端-最近发货接口
export const reqLatelyDeliver = () => ajax(`${head}/v1/logistics/front/lately-deliver`);

// 用户端-我的讲义分页列表接口
export const reqHandoutList = (pageNum, pageSize, orderNo) => ajax(`${head}/v1/logistics/front/my-handout/page-list?pageNum=${pageNum}&pageSize=${pageSize}&orderNo=${orderNo}`);

// 用户端-发货快递分页接口
export const reqExpressList = (pageNum, pageSize, orderNo,sourceFlag) => ajax(`${head}/v1/logistics/front/delivered-express/page-list?pageNum=${pageNum}&pageSize=${pageSize}&orderNo=${orderNo}&sourceFlag=${sourceFlag}`);

// 查询快递详情接口;
export const reqExpressDelivery = (addresseePhone, expressNo) => ajax(`${head}/v1/expressDelivery/query?addresseePhone=${addresseePhone}&expressNo=${expressNo}`);

// 用户端 - 获取待发货讲义数量 - 我的快递入口;
export const reqWaitDeliver = () => ajax(`${head}/v1/logistics/front/get-total/wait-deliver`);

// 用户端-修改收货地址-我的快递入口
export const reqModifyReceivingAddress = (userAddressId) => ajax(`${head}/v1/logistics/front/modify-receiving-address/${userAddressId}`, '', 'PUT');

// 用户端 - 获取待发货讲义数量 - 我的快递入口;
export const getNoBindAddressNum = () => ajax(`${head}/v1/order/unbound-address/count`);

// 用户端-支付成功赠送实物 填写地址
export const reqAddGiftAddress = (data) => ajax(`${head}/v1/pay/success/giveaways/address`, data, 'PUT');
